// This file ensures ActionCable consumer is available globally
// Components create their own dynamic subscriptions with parameters

import getConsumer from './consumer'

// Make consumer available globally for components like Notifications.jsx
window.App = window.App || {}
if (!window.App.cable) {
    window.App.cable = getConsumer()
}
